import React, { useContext, useEffect, useRef, useState } from "react";
import { ContextGlobal } from "../../context";
import { useForm } from "react-hook-form";
import Resizer from "react-image-file-resizer";
import Notification from "../toast";
import { ToastContainer } from "react-toastify";

import api from "../../services/api";
import Modal from "react-modal/lib/components/Modal";
import AvatarEditor from "react-avatar-editor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingFull from "../loading/loading-full";
import { faRedo, faSearchMinus, faSearchPlus, faUndo } from "@fortawesome/free-solid-svg-icons";

import functions from "../../util/functions";

import { removeSpaces } from "../../util/libString";
import reqProduto from "../../services/reqMultiTenant/reqProduto";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY_S3;
const UploadPhotoV1 = ({ nameImg, onChange, width = 250, height = 250 }) => {
	const {
		register,
		handleSubmit,
		formState: { errors, isSubmitting },
	} = useForm();
	const { listPermissionsData } = useContext(ContextGlobal);

	const [show, setShow] = useState(false);
	const [message, setMessage] = useState("");
	const [imagePreview, setImagePreview] = useState("");

	const [scale, setScale] = useState(1);
	const [rotate, setRotate] = useState(0);

	// const [idPhoto, setidPhoto] = useState(0);
	const [path, setPath] = useState("");

	const editorRef = useRef();

	useEffect(() => {
		const handleOpen = () => setShow((prevState) => !prevState);
		window.addEventListener("openUpload", handleOpen);

		return () => {
			window.removeEventListener("openUpload", handleOpen);
		};
	}, []);

	useEffect(() => {
		if (show) {
			handlePermissionS3();
		}
	}, [show]);

	const handlePermissionS3 = async () => {
		//se no cadastro no usuario estiver preenchido o path esta autorizado
		try {
			const IdEmpresa = listPermissionsData?.id_empresa?.toString();

			if (IdEmpresa?.length > 0) {
				const parsedIdEmpresa = parseInt(IdEmpresa, 10);

				if (isNaN(parsedIdEmpresa)) {
					throw new Error("Autorização inválida.");
				}

				const nomeEmpresa = removeSpaces(listPermissionsData?.nome_empresa || "");
				let newPathUrl = parsedIdEmpresa + 251205;
				newPathUrl = newPathUrl.toString() + nomeEmpresa + "_" + nameImg;

				setPath(newPathUrl);
				// setidPhoto(nameImg);
			} else throw new Error("");
		} catch {
			Notification.showToast({
				message:
					"Você não possui autorização para acessar esta área. Por favor, entre em contato com o administrador para obter as permissões necessárias.",
				type: "warning",
			});
			handleClose();
		}
	};

	const handleClose = () => {
		setImagePreview("");
		setScale(1);
		setRotate(0);
		setShow(false);
	};

	//#region redimensionar imagem
	const convertImageToBlob = () => {
		return new Promise((resolve, reject) => {
			if (editorRef.current) {
				editorRef.current.getImage().toBlob(async (blob) => {
					if (blob) {
						try {
							const resizedBlob = await ensureBlobSize(blob);
							resolve(resizedBlob);
						} catch (error) {
							reject(error);
						}
					} else {
						reject(new Error("Failed to create blob"));
					}
				});
			} else {
				reject(new Error("Editor reference is not available"));
			}
		});
	};

	const ensureBlobSize = async (blob) => {
		let quality = 100;
		while (blob.size > 150 * 1024 && quality > 10) {
			blob = await resizeImage(blob, quality);
			quality -= 10;
		}

		return blob;
	};

	const resizeImage = (blob, quality) => {
		return new Promise((resolve) => {
			Resizer.imageFileResizer(
				blob,
				600, // Largura máxima
				600, // Altura máxima
				"JPEG", // Mude para "JPEG"
				quality, // Certifique-se de que a qualidade está sendo aplicada
				0, // Rotação
				(uri) => {
					resolve(uri);
				},
				"blob", // Retorna um blob
			);
		});
	};

	//#endregion

	const uploadImage = async (blob) => {
		const formData = new FormData();

		const namePhoto = `${path}`;

		formData.append("file", blob, namePhoto); // Nome e tipo do arquivo podem ser ajustados

		try {
			const response = await reqProduto.inserirComUploadS3(formData);
			return response;
		} catch (error) {
			throw new Error(error.message);
		}
	};

	const onSubmit = async () => {
		try {
			// Conve			// rt image to blob
			const blob = await convertImageToBlob();

			// Upload image
			const resultMessage = await uploadImage(blob);

			const timestamp = new Date().getTime();

			const data = { url: `${resultMessage}?t=${timestamp}` };

			onChange(data);

			// props.setValue("urlfoto", `${resultMessage}?t=${timestamp}`);

			// setMessage("");

			// props.setIsUpdatedImage(true);

			handleClose();
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
			setMessage("Falha ao enviar arquivo para o servidor. Verifique os dados e tente novamente");
		}
	};

	const handleFileChange = (event) => {
		event.preventDefault();
		const file = event.target.files[0];
		if (file) {
			const fileURL = URL.createObjectURL(file);
			setImagePreview(fileURL);
		}
	};

	const increaseScale = () => {
		setScale((prevScale) => prevScale + 0.1);
	};

	const decreaseScale = () => {
		setScale((prevScale) => {
			const newScale = prevScale - 0.1;
			return newScale < 1 ? 1 : newScale; // Ensure scale does not go below 1
		});
	};

	return (
		<Modal
			isOpen={show}
			onRequestClose={handleClose}
			overlayClassName="react-modal-overlay"
			className="react-modal-form-content z-50"
		>
			<div className="max-w-md p-2 rounded-lg mx-auto">
				<ToastContainer />
				{isSubmitting && <LoadingFull mensagem="Salvando imagem no servidor..." />}
				<h1 className="text-2xl font-bold mb-4">Selecionar Foto</h1>
				<form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
					<div className="flex items-center space-x-2">
						<label className="btn btn-outline-primary">
							<span>Procurar Arquivo</span>
							<input
								type="file"
								accept="image/*"
								disabled={isSubmitting}
								{...register("file", {
									required: "Please select a file",
								})}
								onChange={(e) => {
									register("file").onChange(e);
									handleFileChange(e);
								}}
								className="hidden"
							/>
						</label>
						{errors.file && <p className="text-red-500 text-sm">{errors.file.message}</p>}
					</div>

					{imagePreview && (
						<div className="flex flex-col items-center justify-center w-full ">
							<div className="bg-slate-400">
								<AvatarEditor
									ref={editorRef}
									image={imagePreview}
									width={width}
									height={height}
									border={50}
									borderRadius={0}
									color={[255, 255, 255, 1]}
									scale={scale}
									rotate={rotate}
								/>
							</div>
							<div className=" w-full ">
								<button className="btn btn-primary  w-full  mt-4" type="submit" disabled={isSubmitting}>
									Adicionar Arquivo
								</button>
							</div>
						</div>
					)}
				</form>

				{imagePreview && (
					<>
						<div className="grid grid-cols-1 sm:grid-cols-2 gap-11 items-center mt-4">
							<div className="flex flex-col items-center w-full md:w-60  md:mb-0">
								<div className="flex space-x-4 items-center">
									<button
										className="p-2 text-blue-400 rounded-full hover:text-blue-500"
										disabled={isSubmitting}
										onClick={increaseScale}
									>
										<FontAwesomeIcon icon={faSearchPlus} className="h-6 w-6" />
									</button>
									<h1 className="text-2xl font-bold">Zoom</h1>
									<button
										className="p-2 text-blue-400 rounded-full hover:text-blue-500"
										onClick={decreaseScale}
										disabled={isSubmitting}
									>
										<FontAwesomeIcon icon={faSearchMinus} className="h-6 w-6" />
									</button>
								</div>
							</div>
							<div className="flex flex-col items-center w-full md:w-60 md:mb-0">
								<div className="flex space-x-4 items-center">
									<button
										className="p-2 text-blue-400 rounded-full hover:text-blue-500"
										disabled={isSubmitting}
										onClick={() => {
											setRotate((prevState) => prevState + 10);
										}}
									>
										<FontAwesomeIcon icon={faRedo} className="h-6 w-6" />
									</button>
									<h1 className="text-2xl font-bold">Rotação</h1>
									<button
										className="p-2 text-blue-400 rounded-full hover:text-blue-500"
										disabled={isSubmitting}
										onClick={() => {
											setRotate((prevState) => prevState - 10);
										}}
									>
										<FontAwesomeIcon icon={faUndo} className="h-6 w-6" />
									</button>
								</div>
							</div>
						</div>
					</>
				)}

				{message && <p className="mt-4 text-center text-green-500">{message}</p>}
			</div>
		</Modal>
	);
};

export default UploadPhotoV1;
